export default class ContactFormHandler {
	initForm() {
		if (!document.querySelector('[dynamics-365-form]')) return;

		const old = document.querySelector('script[src*="FormLoader"]');
		if (old) old.remove();

		const script = document.createElement('script');
		script.src = 'https://cxppusa1formui01cdnsa01-endpoint.azureedge.net/eur/FormLoader/FormLoader.bundle.js';
		document.body.appendChild(script);
	}

	destroy() {
		const script = document.querySelector('script[src*="FormLoader"]');
		if (script) script.remove();

		window.d365mktforms = undefined;
		window.d365mkt = undefined;
	}
}
